import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CheckoutState {
  name: string;
  message: string;
  isAnonymous: boolean;
  mediaID: string | null;
  mediaCapability: string | null;
}

export const createCheckoutInitialState = (): CheckoutState => ({
  name: "",
  message: "",
  isAnonymous: false,
  mediaID: null,
  mediaCapability: null,
});

const initialState: CheckoutState = createCheckoutInitialState();

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    setDedication: (
      state,
      action: PayloadAction<{
        name: string;
        message: string;
        isAnonymous: boolean;
      }>
    ) => {
      state.name = action.payload.name;
      state.message = action.payload.message;
      state.isAnonymous = action.payload.isAnonymous;
      localStorage.setItem("checkoutState", JSON.stringify(state));
    },
    setMediaID: (state, action: PayloadAction<string | null>) => {
      state.mediaID = action.payload;
      localStorage.setItem("checkoutState", JSON.stringify(state));
    },
    setGuestMedia: (
      state,
      action: PayloadAction<{ mediaID: string; capability: string } | null>
    ) => {
      state.mediaID = action.payload?.mediaID ?? null;
      state.mediaCapability = action.payload?.capability ?? null;
      localStorage.setItem("checkoutState", JSON.stringify(state));
    },
    clearCheckout: () => {
      localStorage.removeItem("checkoutState");
      return createCheckoutInitialState();
    },
  },
});

export const { setDedication, setMediaID, setGuestMedia, clearCheckout } =
  checkoutSlice.actions;
export default checkoutSlice.reducer;
